<template>
  <DataTable
    ref="DataTable"
    :data-model="'Reservations'"
    :items="reservations"
    :loading="loading"
    @reloadData="reload()"
    :allow-delete="false"
    :allow-create="false"
    :allow-edit="false"
    :allow-view="false"
    :items-per-page="itemsPerPage"
    :exclude-fields="['id', 'consultingRoomId', 'customerId', 'doctorId', 'isFake', 'reservationType', 'color']"
    :display-name-plural="$t('entities.Reservations.Plural')"
    :row-class="(item, type) => {
      if(!item || type !== 'row') return '';
      if(item.color != null) return 'table-row-'+item.color;
      return '';
    }"
    :display-name-singular="$t('entities.MyReservations.Singular')" />
</template>
<script>
import DataTable from '@components/admin/DataTable';

export default {
  components: {
    DataTable
  },
  props: {
    itemsPerPage: {
      type: Number,
      required: false,
      default: 10
    }
  },
  data() {
    return {
      reservations: [],
      loading: true,
    };
  },
  created() {
    this.reload();
  },
  methods: {
    reload() {
      this.loading = true;
      this.axios.get('/admin/reservations').then((res) => {
        if (res.status === 200 && res.data.result.length > 0) {
          this.reservations = res.data.result;
          this.reservations.forEach((x) => {
            x.consultationEnd = this.$moment(x.consultationStart).add({ hours: (Number)(x.conslultationLength.split(':')[0]) }).format('DD.MM.YYYY HH:mm');
            x.consultationStart = this.$moment(x.consultationStart).format('DD.MM.YYYY HH:mm');
            delete x.conslultationLength;
          });

          this.reservations = this.reservations.map((x) => ({
            consultationStart: x.consultationStart,
            consultationEnd: x.consultationEnd,
            customer: x.customer,
            reservationType: x.reservationType,
            doctor: x.doctor,
            color: x.color
          }));
        }
        else {
          this.reservations = [];
        }
        this.loading = false;
      }).catch((err) => Promise.reject(err)).finally(() => {
        this.$refs.DataTable.finishSpinner();
      });
    }
  }
};
</script>
<style lang="scss">
.table-row-0 {
  background-color:rgba(#111111, 0.5) !important;
}

.table-row-1 {
  background-color:rgba(#001f3f, 0.5) !important;
}

.table-row-2 {
  background-color:rgba(#0074D9, 0.5) !important;
}

.table-row-3 {
  background-color:rgba(#7FDBFF, 0.5) !important;
}

.table-row-4 {
  background-color:rgba(#39CCCC, 0.5) !important;
}

.table-row-5 {
  background-color:rgba(#3D9970, 0.5) !important;
}

.table-row-6 {
  background-color:rgba(#2ECC40, 0.5) !important;
}

.table-row-7 {
  background-color:rgba(#01FF70, 0.5) !important;
}

.table-row-8 {
  background-color:rgba(#FFDC00, 0.5) !important;
}

.table-row-9 {
  background-color:rgba(#FF851B, 0.5) !important;
}

.table-row-10 {
  background-color:rgba(#FF4136, 0.5) !important;
}

.table-row-11 {
  background-color:rgba(#85144b, 0.5) !important;
}

.table-row-12 {
  background-color:rgba(#F012BE, 0.5) !important;
}

.table-row-13 {
  background-color:rgba(#B10DC9, 0.5) !important;
}

.table-row-14 {
  background-color:rgba(#AAAAAA, 0.5) !important;
}

.table-row-15 {
  background-color:rgba(#DDDDDD, 0.5) !important;
}

.table-row-16 {
  background-color:rgba(#FFFFFF, 0.5) !important;
}
</style>
